import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx, Transition as _Transition, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/icon-share-testimony.png'


const _withScopeId = n => (_pushScopeId("data-v-52b0c268"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "themes-page" }
const _hoisted_2 = { class: "themes" }
const _hoisted_3 = {
  key: 0,
  class: "temp-listing",
  "aria-hidden": "true"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_8 = { class: "screen-reader" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SideMenu = _resolveComponent("SideMenu")!
  const _component_MemorialAudio = _resolveComponent("MemorialAudio")!
  const _component_MemorialVideo = _resolveComponent("MemorialVideo")!
  const _component_MemorialText = _resolveComponent("MemorialText")!
  const _component_BaseModal = _resolveComponent("BaseModal")!
  const _component_ShareTestimonyModal = _resolveComponent("ShareTestimonyModal")!
  const _component_CreditModal = _resolveComponent("CreditModal")!
  const _component_ThemesActionButton = _resolveComponent("ThemesActionButton")!
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_FloatingActionButton = _resolveComponent("FloatingActionButton")!
  const _component_MainLayout = _resolveComponent("MainLayout")!
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_MainLayout, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.isDev)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
                _createElementVNode("li", null, [
                  _createElementVNode("button", {
                    class: "btn",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.devSetTheme()))
                  }, "Afficher les modales")
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modals, (modal, index) => {
                  return (_openBlock(), _createElementBlock("li", { key: index }, [
                    _createElementVNode("button", {
                      class: "btn",
                      onClick: ($event: any) => (_ctx.openModal(modal.id))
                    }, "Modale - " + _toDisplayString(modal.type), 9, _hoisted_4)
                  ]))
                }), 128)),
                _createElementVNode("li", null, [
                  _createElementVNode("button", {
                    class: "btn",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openEndExperienceCredit()))
                  }, "Crédits fin expérience")
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("button", {
                    class: "btn",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showShareTestimonialButton()))
                  }, "Afficher bouton partager un témoignage")
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("button", {
                    class: "btn",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openShareTestimonialWithEventBus()))
                  }, "Ouvrir partage avec event bus")
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("button", {
                    class: "btn",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openToast()))
                  }, "Message d'erreur")
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("button", {
                    class: "btn",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.clearStorage()))
                  }, "Cookie Consent")
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("button", {
                    class: "btn",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showOtherThemes()))
                  }, "Bouton Autres thèmes")
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("button", {
                    class: "btn",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showBreadcrumb()))
                  }, "Afficher Fil d'ariane")
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("button", {
                    class: "btn",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.hideBreadcrumb()))
                  }, "Cacher Fil d'ariane")
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_SideMenu),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modals, (modal, index) => {
            return (_openBlock(), _createBlock(_component_BaseModal, {
              key: index,
              id: modal.id,
              backdropExit: true,
              show: modal.show,
              allowExit: true,
              showExit: true,
              onClosed: ($event: any) => (_ctx.onClosed(modal.id))
            }, {
              default: _withCtx(() => [
                (modal.type === 'audio')
                  ? (_openBlock(), _createBlock(_component_MemorialAudio, {
                      key: 0,
                      options: modal
                    }, null, 8, ["options"]))
                  : _createCommentVNode("", true),
                (modal.type === 'video')
                  ? (_openBlock(), _createBlock(_component_MemorialVideo, {
                      key: 1,
                      options: modal
                    }, null, 8, ["options"]))
                  : _createCommentVNode("", true),
                (modal.type === 'text_and_image')
                  ? (_openBlock(), _createBlock(_component_MemorialText, {
                      key: 2,
                      options: modal
                    }, null, 8, ["options"]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["id", "show", "onClosed"]))
          }), 128)),
          _createVNode(_component_ShareTestimonyModal, {
            show: _ctx.showShareTestimonial,
            showExit: _ctx.isAllowedToExit,
            submitAnimation: _ctx.shareSubmit,
            openWithBusEvent: _ctx.openWithBusEvent,
            onShareFinish: _ctx.onShareSubmit,
            onStep: _ctx.onShareStep,
            onRecordingStatus: _ctx.recordingStatusChanged,
            onClose: _ctx.onShareTestimonialClose
          }, null, 8, ["show", "showExit", "submitAnimation", "openWithBusEvent", "onShareFinish", "onStep", "onRecordingStatus", "onClose"]),
          _createVNode(_component_CreditModal),
          _createVNode(_Transition, { name: "morethemes" }, {
            default: _withCtx(() => [
              (_ctx.otherThemesVisibility)
                ? (_openBlock(), _createBlock(_component_ThemesActionButton, { key: 0 }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_Transition, { name: "breadcrumb" }, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(_component_Breadcrumb, null, null, 512), [
                [_vShow, _ctx.breadCrumbVisibility]
              ])
            ]),
            _: 1
          }),
          _withDirectives(_createElementVNode("div", null, [
            (_ctx.displayPrevNext)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn-round-arrow prev",
                  id: "btn_show_prev",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showPrev())),
                  disabled: !_ctx.enablePrevButton
                }, null, 8, _hoisted_5))
              : _createCommentVNode("", true),
            (_ctx.displayPrevNext)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "btn-round-arrow next",
                  id: "btn_show_next",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showNext())),
                  disabled: !_ctx.enableNextButton
                }, null, 8, _hoisted_6))
              : _createCommentVNode("", true)
          ], 512), [
            [_vShow, _ctx.isThemeSelection]
          ]),
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              (_ctx.showShareTestimonialBtn)
                ? (_openBlock(), _createBlock(_component_FloatingActionButton, {
                    key: 0,
                    onClicked: _cache[11] || (_cache[11] = ($event: any) => (_ctx.openShareTestimonial())),
                    class: _normalizeClass({ 'slow-fade-in': _ctx.delayedToggleShowShareBtn }),
                    classes: ['btn-share-testimony']
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7,
                      _withDirectives(_createElementVNode("span", _hoisted_8, null, 512), [
                        [_directive_translate, `testimonial.share_testinomy`]
                      ])
                    ]),
                    _: 1
                  }, 8, ["class"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ]))
}